module.exports = __webpack_public_path__ + "static/media/Delivery.ae38d731.svg";